// Canonical list of supported languages with their NATIVE names, in the
// display order used across the app (login header, register, settings) so the
// language dropdowns always read in the language they select — never English.
export const SUPPORTED_LANGUAGES = [
  { code: "cy", name: "Cymraeg" },
  { code: "gd", name: "Gàidhlig" },
  { code: "en", name: "English" },
  { code: "ar", name: "العربية" },
  { code: "bn", name: "বাংলা" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "gu", name: "ગુજરાતી" },
  { code: "pa", name: "ਪੰਜਾਬੀ" },
  { code: "pl", name: "Polski" },
  { code: "pt", name: "Português" },
  { code: "ro", name: "Română" },
  { code: "so", name: "Soomaali" },
  { code: "tr", name: "Türkçe" },
  { code: "ur", name: "اردو" },
];

/**
 * TEMPORARY: Keep this disabled so every user can select any supported
 * language before registration and before their organisation is known.
 *
 * FUTURE: Set this to true when organisation-controlled language selection is
 * ready to be enforced across login, registration and signed-in user pages.
 * Admin and superadmin pages are intentionally unaffected and remain English.
 */
export const ORGANIZATION_LANGUAGE_CONTROL_ENABLED = false;

const NATIVE_NAME_BY_CODE = SUPPORTED_LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = lang.name;
  return acc;
}, {});

// Canonical display order (index) for a language code.
const ORDER_BY_CODE = SUPPORTED_LANGUAGES.reduce((acc, lang, index) => {
  acc[lang.code] = index;
  return acc;
}, {});

/** Native name for a language code, falling back to a provided name, then the code. */
export const nativeLanguageName = (code, fallbackName) =>
  NATIVE_NAME_BY_CODE[String(code || "").toLowerCase()] || fallbackName || code;

/**
 * Map an org's supported-language list (which may carry English `name`s from the
 * API) to entries that DISPLAY the native name, keeping the org's enabled set
 * and sorting them into the canonical order so the list matches the mobile app.
 */
export const withNativeNames = (languages = []) =>
  (Array.isArray(languages) ? languages : [])
    .filter((lang) => lang && lang.code)
    .map((lang) => ({ ...lang, name: nativeLanguageName(lang.code, lang.name) }))
    .sort(
      (a, b) =>
        (ORDER_BY_CODE[a.code] ?? Number.MAX_SAFE_INTEGER) -
        (ORDER_BY_CODE[b.code] ?? Number.MAX_SAFE_INTEGER)
    );
